import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import WorkOrderService from 'src/app/services/WorkOrder';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import PRNService from 'src/app/services/PrnService';

@Component({
  selector: 'app-project-and-contract-details',
  templateUrl: './project-and-contract-details.component.html',
  styleUrls: ['./project-and-contract-details.component.scss']
})
export class ProjectAndContractDetailsComponent implements OnInit {

  existingDlpId: number | null = null;
  isLoading: boolean = false;

  // --- Dropdown lists ---
  dlpApplicableList: string[] = ['Yes', 'No'];

  dlpStartBasisList: string[] = [
    'Completion Date',
    'Handover Date',
    'Inspection Date'
  ];

  dlpStatusList: string[] = ['Active', 'Completed', 'Expired'];

  inspectionFrequencyList: string[] = [
    'Monthly',
    'Quarterly',
    'Half-Yearly',
    'Yearly'
  ];

  dlpClosureApprovalList: string[] = [
    'Pending',
    'Approved',
    'Rejected'
  ];

  // --- File upload tracking ---
  completionCertFileName: string = '';
  dlpDocFileName: string = '';
  completionCertFile: File | null = null;
  dlpDocFile: File | null = null;

  // --- Existing uploaded files ---
  dlpCertFiles: any[] = [];
  dlpDocFiles: any[] = [];

  // --- Project details model ---
  projectDetails = {
    workorderId: null as any,
    dlpReferenceNo: '',
    projectName: '',
    clientId: null as number | null,
    clientName: '',
    projectType: '',
    contractNo: '',
    workCompletionDate: '' as any,
    dlpStartDate: '' as any,
    dlpEndDate: '' as any,
    dlpDuration: '' as any,
    retentionAmount: '' as any,
    dlpStatus: 'Active',
    responsibleEngineer: '',
    dlpApplicable: 'YES',
    dlpStartBasis: 'Completion Date',
    retentionReleaseDate: '' as any,
    inspectionFrequency: 'Monthly',
    openComplaints: 0,
    dlpClosureApproval: 'Pending',
    dlpRemarks: '',
  };

  constructor(
    private dialogRef: MatDialogRef<ProjectAndContractDetailsComponent>,
    private workOrderService: WorkOrderService,
    private prnService: PRNService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}


  ngOnInit(): void {
    if (this.data) {
      this.projectDetails.workorderId  = this.data.workOrderKey || this.data.workOrderkey;
      this.projectDetails.clientId     = this.data.clientKey ?? null;
      this.projectDetails.clientName   = this.data.clientName ?? '';
      this.projectDetails.projectName  = this.data.siteName || '';
      this.projectDetails.projectType  = this.data.projectType || '';
    }

    if (this.projectDetails.workorderId) {
      this.isLoading = true;

      // Fetch existing DLP record
      this.workOrderService.getDlpByWorkorderId(this.projectDetails.workorderId).subscribe({
        next: (response: any) => {
          console.log('=== DLP API RESPONSE ===', response);
          // Handle cases where response might be wrapped in { data: ... } or an array [ ... ]
          const res = Array.isArray(response) ? response[0] : (response?.data || response);

          if (res) {
            this.existingDlpId = res.id;

            // Check all possible property naming variations for DLP Reference No
            this.projectDetails.dlpReferenceNo      = res.dlpReferenceNo || res.dlpRefNo || res.dlpReferenceNum || res.referenceNo || '';

            this.projectDetails.projectName         = res.projectName ?? this.projectDetails.projectName;
            this.projectDetails.projectType         = res.projectType ?? this.projectDetails.projectType;
            this.projectDetails.contractNo          = res.contractNo ?? '';
            this.projectDetails.dlpApplicable       = res.dlpApplicable ?? 'Yes';
            this.projectDetails.dlpDuration         = res.dlpDuration ?? '';
            this.projectDetails.dlpStartBasis       = res.dlpStartBasis ?? 'Completion Date';
            this.projectDetails.dlpStatus           = res.dlpStatus ?? 'Active';
            this.projectDetails.dlpStartDate        = res.dlpStartDate ? new Date(res.dlpStartDate) : '';
            this.projectDetails.dlpEndDate          = res.dlpEndDate ? new Date(res.dlpEndDate) : '';
            this.projectDetails.retentionAmount     = res.retentionAmount ?? '';
            this.projectDetails.retentionReleaseDate = res.retentionReleaseDate ? new Date(res.retentionReleaseDate) : '';
            this.projectDetails.inspectionFrequency = res.inspectionFrequency ?? 'Monthly';
            this.projectDetails.responsibleEngineer = res.responsibleEngineer ?? '';
            this.projectDetails.openComplaints      = res.openComplaints ?? 0;
            this.projectDetails.dlpClosureApproval  = res.dlpClosureApproval ?? 'Pending';
            this.projectDetails.dlpRemarks          = res.dlpRemarks ?? '';
            this.projectDetails.workCompletionDate  = res.workCompletionDate ? new Date(res.workCompletionDate) : '';
          }
          this.isLoading = false;
        },
        error: () => {
          this.existingDlpId = null;
          this.isLoading = false;
        }
      });

      // Fetch existing uploaded files for both modules
      this.fetchDlpFiles();
    }
  }
  // ngOnInit(): void {
  //   if (this.data) {
  //     this.projectDetails.workorderId  = this.data.workOrderKey || this.data.workOrderkey;
  //     this.projectDetails.clientId     = this.data.clientKey ?? null;
  //     this.projectDetails.clientName   = this.data.clientName ?? '';
  //     this.projectDetails.projectName  = this.data.siteName || '';
  //     this.projectDetails.projectType  = this.data.projectType || '';
  //   }

  //   if (this.projectDetails.workorderId) {
  //     this.isLoading = true;

  //     // Fetch existing DLP record
  //     this.workOrderService.getDlpByWorkorderId(this.projectDetails.workorderId).subscribe({
  //       next: (res: any) => {
  //         if (res) {
  //           this.existingDlpId = res.id;

  //           this.projectDetails.dlpReferenceNo      = res.dlpReferenceNo ?? '';
  //           this.projectDetails.projectName         = res.projectName ?? this.projectDetails.projectName;
  //           this.projectDetails.projectType         = res.projectType ?? this.projectDetails.projectType;
  //           this.projectDetails.contractNo          = res.contractNo ?? '';
  //           this.projectDetails.dlpApplicable       = res.dlpApplicable ?? 'Yes';
  //           this.projectDetails.dlpDuration         = res.dlpDuration ?? '';
  //           this.projectDetails.dlpStartBasis       = res.dlpStartBasis ?? 'Completion Date';
  //           this.projectDetails.dlpStatus           = res.dlpStatus ?? 'Active';
  //           this.projectDetails.dlpStartDate        = res.dlpStartDate ? new Date(res.dlpStartDate) : '';
  //           this.projectDetails.dlpEndDate          = res.dlpEndDate ? new Date(res.dlpEndDate) : '';
  //           this.projectDetails.retentionAmount     = res.retentionAmount ?? '';
  //           this.projectDetails.retentionReleaseDate = res.retentionReleaseDate ? new Date(res.retentionReleaseDate) : '';
  //           this.projectDetails.inspectionFrequency = res.inspectionFrequency ?? 'Monthly';
  //           this.projectDetails.responsibleEngineer = res.responsibleEngineer ?? '';
  //           this.projectDetails.openComplaints      = res.openComplaints ?? 0;
  //           this.projectDetails.dlpClosureApproval  = res.dlpClosureApproval ?? 'Pending';
  //           this.projectDetails.dlpRemarks          = res.dlpRemarks ?? '';
  //           this.projectDetails.workCompletionDate  = res.workCompletionDate ? new Date(res.workCompletionDate) : '';
  //         }
  //         this.isLoading = false;
  //       },
  //       error: () => {
  //         this.existingDlpId = null;
  //         this.isLoading = false;
  //       }
  //     });

  //     // Fetch existing uploaded files for both modules
  //     this.fetchDlpFiles();
  //   }
  // }

  // --- Fetch uploaded files ---
  fetchDlpFiles(): void {
    const workorderId = this.projectDetails.workorderId;
    if (!workorderId) return;

    this.prnService.fetchUploadFile({ module: 'DLP_certificate', id: workorderId })
      .subscribe({
        next: (res: any[]) => { this.dlpCertFiles = res || []; },
        error: () => { this.dlpCertFiles = []; }
      });

    this.prnService.fetchUploadFile({ module: 'DLP_doc', id: workorderId })
      .subscribe({
        next: (res: any[]) => { this.dlpDocFiles = res || []; },
        error: () => { this.dlpDocFiles = []; }
      });
  }

  // --- File selection handlers ---
  onCompletionCertSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.completionCertFile = input.files[0];
      this.completionCertFileName = input.files[0].name;
    }
  }

  onDlpDocSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.dlpDocFile = input.files[0];
      this.dlpDocFileName = input.files[0].name;
    }
  }

  // --- Download handler ---
  downloadDlpFile(event: Event, type: 'certificate' | 'doc'): void {
    event.stopPropagation(); // prevent triggering file input click

    const files = type === 'certificate' ? this.dlpCertFiles : this.dlpDocFiles;

    if (!files || files.length === 0) {
      this.snackBar.open('No document found', 'Close', { duration: 3000 });
      return;
    }

    this.prnService.downloadFromS3(files[0].filePath).subscribe({
      next: (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = files[0].fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.snackBar.open('File downloaded successfully', 'Close', { duration: 3000 });
      },
      error: () => {
        this.snackBar.open('Download failed', 'Close', { duration: 3000 });
      }
    });
  }

  // --- Save / Update ---
  save(): void {
    const payload = {
      workorderId:          this.projectDetails.workorderId,
      dlpReferenceNo:       this.projectDetails.dlpReferenceNo,
      projectName:          this.projectDetails.projectName,
      clientId:             this.projectDetails.clientId ? Number(this.projectDetails.clientId) : null,
      projectType:          this.projectDetails.projectType || null,
      contractNo:           this.projectDetails.contractNo || null,
      workCompletionDate:   this.formatDate(this.projectDetails.workCompletionDate),
      dlpStartDate:         this.formatDate(this.projectDetails.dlpStartDate),
      dlpEndDate:           this.formatDate(this.projectDetails.dlpEndDate),
      dlpDuration:          Number(this.projectDetails.dlpDuration),
      retentionAmount:      this.projectDetails.retentionAmount === '' ? null : Number(this.projectDetails.retentionAmount),
      dlpStatus:            this.projectDetails.dlpStatus,
      responsibleEngineer:  this.projectDetails.responsibleEngineer || null,
      dlpApplicable:        this.projectDetails.dlpApplicable,
      dlpStartBasis:        this.projectDetails.dlpStartBasis,
      retentionReleaseDate: this.formatDate(this.projectDetails.retentionReleaseDate),
      inspectionFrequency:  this.projectDetails.inspectionFrequency,
      openComplaints:       Number(this.projectDetails.openComplaints),
      dlpClosureApproval:   this.projectDetails.dlpClosureApproval,
      dlpRemarks:           this.projectDetails.dlpRemarks || null,
    };

    const request$ = this.existingDlpId
      ? this.workOrderService.updateProjectContractDetails(this.existingDlpId, payload)
      : this.workOrderService.saveProjectContractDetails(this.projectDetails.workorderId, payload);

    request$.subscribe({
      next: (res) => {
        this.snackBar.open(
          this.existingDlpId ? 'Updated successfully' : 'Saved successfully',
          'Close',
          { duration: 3000 }
        );
        this.uploadDlpFiles(this.projectDetails.workorderId);
        this.dialogRef.close(res);
      },
      error: (err) => {
        console.error(err);
        this.snackBar.open('Save failed', 'Close', { duration: 3000 });
      }
    });
  }

  // --- Upload files (delete old first to enforce one file per module) ---
  private uploadDlpFiles(workOrderId: any): void {
    if (this.completionCertFile) {
      const formData = new FormData();
      formData.append('file', this.completionCertFile);

      if (this.dlpCertFiles.length > 0) {
        this.prnService.DELETEFILE('DLP_certificate', this.dlpCertFiles[0].fileName)
          .subscribe({
            next: () => this.uploadCertFile(formData, workOrderId),
            error: () => this.uploadCertFile(formData, workOrderId)
          });
      } else {
        this.uploadCertFile(formData, workOrderId);
      }
    }

    if (this.dlpDocFile) {
      const formData = new FormData();
      formData.append('file', this.dlpDocFile);

      if (this.dlpDocFiles.length > 0) {
        this.prnService.DELETEFILE('DLP_doc', this.dlpDocFiles[0].fileName)
          .subscribe({
            next: () => this.uploadDocFile(formData, workOrderId),
            error: () => this.uploadDocFile(formData, workOrderId)
          });
      } else {
        this.uploadDocFile(formData, workOrderId);
      }
    }
  }

  private uploadCertFile(formData: FormData, workOrderId: any): void {
    this.prnService.uploadToS3(formData, 'DLP_certificate', workOrderId).subscribe({
      next: () => {
        this.snackBar.open('Certificate uploaded successfully', 'Close', { duration: 3000 });
        this.fetchDlpFiles();
      },
      error: () => this.snackBar.open('Certificate upload failed', 'Close', { duration: 3000 })
    });
  }

  private uploadDocFile(formData: FormData, workOrderId: any): void {
    this.prnService.uploadToS3(formData, 'DLP_doc', workOrderId).subscribe({
      next: () => {
        this.snackBar.open('DLP Document uploaded successfully', 'Close', { duration: 3000 });
        this.fetchDlpFiles();
      },
      error: () => this.snackBar.open('DLP Document upload failed', 'Close', { duration: 3000 })
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  private formatDate(date: any): string | null {
    return date ? new Date(date).toISOString() : null;
  }
}